/**
 * Prevents users from clicking on an element.
 *
 * Useful for anchor tags or for check boxes or other interactive elements.
 */
var $ = require('js/sw-jquery/sw-jquery');

$(function() {
  $('body').on('click', '[data-sw-prevent-click]', function(e) {
    e.preventDefault();

    return false;
  });
});
